import React, { Component } from 'react';
import './AddCandidates.css';
import { Grid, Row, Col } from 'react-bootstrap';
import { Form, FormGroup, FormControl, HelpBlock, ControlLabel, InputGroup } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Icon from '../../UI/Icon/Icon';
import imageLoader from '../../../assets/images/image-loader2.gif';
import CvUpload from '../../../hoc/CvParsing/CvUpload.js';
import { checkValidity } from '../../../shared/utility';
import MediaQuery from 'react-responsive';
import errorIcon from'../../../assets/images/red-alert.svg'
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';

/**
 * @desc show importrd candidate details under specific job title
 * @param props
 * @return DOMElement
 */
const CandidateImportRow = (props) => {
  let statusEmail = null;
  if(props.emailStatus){
    statusEmail = props.emailStatus.email
  }
  return (
    <tr>
      <td className="date-added hidden-xs">{props.dateAdded}</td>
      <td className="bullhorn-id">{props.bullhornID}</td>
      <td className="name">
        <div>{props.name}</div>
        {props.current_job_title?<div className="current-position">{props.current_job_title}</div>:""}
        <MediaQuery query="(max-device-width: 768px)">
          <div className="emailstatusmobile" title={props.email}>
            {props.email? statusEmail? props.email !== statusEmail? <div>
            {props.email}
            <span className="emailidstatus">
            <Icon icon="email-missing"></Icon>
            <p>Email ID mismatch</p>
            </span>
            </div>
            : props.email : props.email : <div><span className="emailidstatus">
            <Icon icon="email-missing"></Icon>
            <p>Email ID missing</p>
            </span></div>}
          </div>
        </MediaQuery>
      </td>
      <td className="email hidden-xs" title={props.email}>
        {props.email? statusEmail? props.email !== statusEmail? <div>
          {props.email}
          <span className="emailidstatus">
            <Icon icon="email-missing"></Icon>
            <p>Email ID mismatch</p>
          </span>
        </div>
        : props.email : props.email : <div><span className="emailidstatus">
            <Icon icon="email-missing"></Icon>
            <p>Email ID missing</p>
          </span></div>}
      </td>
      <td className="actions" onClick={() => props.deleteCandidateModal(props.bullhornID)}><Icon icon="remove"  className="" /></td>
    </tr>
  );
}
const Fnpsuedotable = (props) => {
return (
<tr className="add-candidates-to-job-dummy-table"><td className="date-added hidden-xs"></td><td className="bullhorn-id"></td><td className="name"></td><td className="email hidden-xs"></td><td className="actions"></td></tr>);
}
/**
 * @desc Add candidates with bullhornId under specific job title
 * @param props
 * @return DOMElement
 */
const AddCandidates = (props) => { 
  let disableUploadCv = (props.candidateId && props.candidateEmail !== ''&& checkValidity(props.candidateId,'isNumeric')&& checkValidity(props.candidateEmail,'isEmail')&&props.fileName =='')?false:true;
  var fileTypes = ["application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/msword", "application/pdf",  "text/plain"];

  return (
    <Form className="candidate-form">
      <Row className="candidate-steps show-grid">
        <Col xs={12} sm={5} className="form-section candidate-details">
          <h2>Candidate Details</h2>
          {/* <p>Add candidate(s) to the  '{props.jobTitle}'  job using Bullhorn ID</p> */}
          <FormGroup
            controlId="formBasicText"
          >
            <ControlLabel>Bullhorn ID: </ControlLabel>
            <InputGroup>
              <FormControl
                // className={props.importLoader?"import-input-loader":""}
                type="text"
                placeholder="e.g. 45678"
                value={props.candidateId}
                onBlur={props.handleCandidateIdBlur}
                onChange={props.handleCandidateIdChange}
                onKeyPress={props.handleKeyPressCandidateId}
                disabled={props.disableCandidateFields}
                >
              </FormControl>
              {/* <InputGroup.Button>
                <Button 
                  className="btn-import" 
                  onClick={props.getCandidate} 
                  disabled={props.importButtonDisable?true:false}>Import</Button>
              </InputGroup.Button> */}
            </InputGroup>

            <p className="error-message">{props.errorPositioncandidateId==='candidateId'?"Please enter valid Bullhorn ID":""}</p>

          
          </FormGroup>
          <FormGroup className="cv-upload-section">          
          <ControlLabel>Email ID: </ControlLabel>
          <InputGroup>
            <FormControl
              id="email-import"
              className="email-import"
              type="text"
              placeholder="email"
              value={props.candidateEmail}
              onBlur={props.handleCandidateEmailBlur}
              onChange={props.handleCandidateEmailChange}
              onKeyPress={(e) => {
                if(e.charCode === 32){
                  e.preventDefault();
                }
              }}
              >
            </FormControl>
            </InputGroup>
            <p className="error-message">{props.errorPositionEmail==='Email'?"Please enter valid email":""}</p>
                <CvUpload 
                   multiple={false}
                  buttonText="Upload CV"
                  maxSize ={1024*5120}
                  acceptedTypes = ".doc,.docx,.pdf,.txt"
                  handleFileSelect={props.addFile}
                  handleFileRemove={props.handleRemoveFile}
                  onclickAttach = {props.handleAttachClick}
                  progressPercent={props.progressPercent}
                  selectedFiles = {props.fileName}
                  DragAcceptedTypes = {fileTypes}
                  id={props.candidateId}
                  disabled={disableUploadCv}
                  fileUploaded={props.fileUploaded}
                />
                {props.fileName && props.fileName !==''?
                  <Button
                    className="upload-cv" 
                    onClick={props.getCandidate}
                    disabled={props.addCandidatebutton?true:false}>
                      {props.importLoader && props.fileName && props.fileName !==''&& !props.networkError?
                        <div className ="import-loader-content">
                          <p className ="import-loader-content-p">Loading<span className="import-loader-dots"></span></p>
                        </div>
                      :"Add Candidate"}
                 </Button>
                :""
                }

                {props.networkError ?
                  <div className="attach-loading-error">
                    <div className="toast-icon"><img src={errorIcon}/></div>
                    <div className="toast-message">
                      <span>Sorry, there was an error processing your request</span>
                    </div>
                  </div> :"" }  
          </FormGroup>
          
        </Col>
        <Col xs={12} sm={7} className="form-section candidate-details-list">
          <h2 className="hidden-xs">List of Candidates Added</h2>
          {(props.candidates.length > 0 && !props.candidates[0].message)? 
            <div className="scroll-table">
            <Table striped condensed hover>
              <thead>
                <tr>
                  <th className="date-added hidden-xs">Date Added</th>
                  <th className="bullhorn-id">Bullhorn ID</th>
                  <th className="name">Name</th>
                  <th className="email hidden-xs">Email</th>
                  <th className="actions">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {props.candidates.map((candidate, index) => (
                  console.log("PG candidate details", candidate),
                   <CandidateImportRow 
                    key={index}
                    bullhornID={candidate.candidate_source_id} 
                    dateAdded={new Date(candidate.candidate_added_date).toISOString().replace(/T.*/,'').split('-').reverse().join('/')} 
                    name={candidate.candidate_name}
                    current_job_title={(typeof(candidate.current_job_title) === 'undefined' || candidate.current_job_title ===null)?"Actively Seeking Employment":candidate.current_job_title}
                    email={candidate.email} 
                    deleteCandidateModal={(event)=>props.deleteCandidateModal(index,candidate.candidate_source_id)}
                    emailStatus = {props.emailsList.find(list => list.BHID == candidate.candidate_source_id)}
                    //{candidate.email? candidate.email !== props.emailsList[index]? 'mismatch':'match' : 'noemail'}
                  />
                ))}
                {(props.candidates.length < 3 ) ?
                  [...Array(3-props.candidates.length)].map((row) => (
                  <Fnpsuedotable />
                  ))
                : 
                ''
                }
               
              </tbody>
            </Table>
            </div> : 
            
            <Table striped condensed hover>
              <thead>
                <tr>
                  <th className="date-added hidden-xs">Date Added</th>
                  <th className="bullhorn-id">Bullhorn ID</th>
                  <th className="name">Name</th>
                  <th className="email hidden-xs">Email</th>
                  <th className="actions">&nbsp;</th>
                </tr>
              </thead>
              <tbody className="add-candidates-to-job-dummy-table">
                <tr>
                  <td className="date-added hidden-xs"></td>
                  <td className="bullhorn-id"></td>
                  <td className="name"></td>
                  <td className="email hidden-xs"></td>
                  <td className="actions"></td>
                </tr>
                <tr>
                  <td className="date-added hidden-xs"></td>
                  <td className="bullhorn-id"></td>
                  <td className="name"></td>
                  <td className="email hidden-xs"></td>
                  <td className="actions"></td>
                </tr>
                <tr>
                  <td className="date-added hidden-xs"></td>
                  <td className="bullhorn-id"></td>
                  <td className="name"></td>
                  <td className="email hidden-xs"></td>
                  <td className="actions"></td>
                </tr>
              </tbody>
            </Table>          }
        </Col>
      </Row>
    </Form>
  );
}

export default AddCandidates;


// WEBPACK FOOTER //
// ./src/components/Recruiter/AddCandidates/AddCandidates.js